// require lib
import Vue from 'vue'
import VueCodemirror from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'

// require more codemirror resource...
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/theme/base16-dark.css'

// you can set default global options and events when use
Vue.use(VueCodemirror,  { 
  options: {
    tabSize: 2,
    theme: 'base16-dark', 
    lineNumbers: true,
    line: true,
  },
  // events: ['scroll', ...]
} )